"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.filterKey = void 0;
function filterKey(subject, predicate, thisArg) {
    return Object.keys(subject).filter(function (k, i, a) {
        return predicate.apply(this, [k, i, a, subject]);
    }, thisArg);
}
exports.filterKey = filterKey;
//# sourceMappingURL=filterKey.js.map